










































































































































































































































































































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import Product from "../../../store/entities/product";
import AppConsts from "@/lib/appconst";
import _ from "lodash";
import EditSaveProduct from './edit-save-product.vue'

@Component({
  components: {EditSaveProduct}
})
export default class EditProduct extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  product: Product = new Product();
  spinShow: boolean = false;
  isShowLengthOfSerial: boolean = true;
  imageUrl: string = "";
  isUpload: boolean = false;
  id: number = 0;
  dataChildProducts = [];
  loading: boolean = false;
  editSaveModalShow: boolean = false;
  clients: [] = [];
  selectChildClientCode: string = "";
  categoriesOfClient: [] = [];
  selectChildCategoryId: number = 0;
  unitsOfClient: [] = [];
  selectChildUnitId: number = 0;
  serviceProductType = AppConsts.productTypes.service;

  async created() {
    this.spinShow = true;
    try {
      await this.$store.dispatch({
        type: "product/getListStorageTypesForSelect",
      });
      await this.$store.dispatch({
        type: "product/getListInventModelsForSelect",
      });
      await this.$store.dispatch({
        type: "product/getListProductTypesForSelect",
      });
      await this.$store.dispatch({
        type: "product/getListTypesForSelect",
      });
      await this.$store.dispatch({
        type: "unit/getListForSelect",
      });
      await this.$store.dispatch({
        type: "category/getListForSelect",
      });
      await this.$store.dispatch({
        type: "masterData/getBrands",
      });
      if (!this.isTenant() && !this.isClient()) {
        await this.getClients();
      }
      this.id = +this.$root.$router.currentRoute.params.id;
      await this.getProductInfo();
      if (this.product.storageType == AppConsts.storageType.serial)
        this.isShowLengthOfSerial = true;
      else this.isShowLengthOfSerial = false;
      this.spinShow = false;
    } catch (error) {
      this.spinShow = false;
    }
  }
  get units() {
    return this.$store.state.unit.unitsForSelect;
  }
  get categories() {
    return this.$store.state.category.categoriesForSelect;
  }
  get storageTypes() {
    return this.$store.state.product.storageTypes;
  }
  get inventModels() {
    return this.$store.state.product.inventModels;
  }
  get productTypes() {
    return this.$store.state.product.productTypes;
  }
  get types() {
    return this.$store.state.product.types;
  }
  get brands() {
    return this.$store.state.masterData.brands;
  }
  isClient() {
    return !_.isNil(this.$store.state.session.client);
  }
  isTenant() {
    return !_.isNil(this.$store.state.session.tenant);
  }
  showClientModel() {
    this.editSaveModalShow=true;
  }
  save() {
    this.$store.commit('product/editSave',this.dataChildProducts);
    this.showClientModel()
  }
  confirmSave() {
    this.$Modal.confirm({
      title: this.L("Tips"),
      content: this.L("Confirm.UpdateProduct"),
      okText: this.L("Yes"),
      cancelText: this.L("No"),
      onOk: async () => {
        this.spinShow = true;
        try {
          if (this.isClient()) {
            this.product.items = [];
            await this.$store.dispatch({
              type: "product/update",
              data: this.product,
            });
          } else {
            this.product.items = this.dataChildProducts;
            await this.$store.dispatch({
              type: "product/updateMaster",
              data: this.product,
            });
          }
          Util.showSuccessMsg(this, "Success.UpdateProduct");
          this.$emit("save-success");
          this.onGoBack();
          this.spinShow = false;
        } catch (error) {
          this.spinShow = false;
        }
      },
    });
  }
  onGoBack() {
    (this.$refs.productForm as any).resetFields();
    this.$emit("input", false);
    this.$root.$router.push({ name: "product" });
  }
  onChangeStorageType() {
    if (this.product.storageType == AppConsts.storageType.serial) {
      this.isShowLengthOfSerial = true;
    } else {
      this.isShowLengthOfSerial = false;
      this.product.lengthOfSerialNo = 0;
    }
  }
  handleBeforeUpload(file) {
    const fileExt = file.name.split(".").pop().toLocaleLowerCase();

    if (
      fileExt === "jpep" ||
      fileExt === "jpg" ||
      fileExt === "png" ||
      fileExt === "gif" ||
      fileExt === "jfif"
    ) {
      let data = new FormData();
      data.append("file", file);

      this.$store.dispatch("product/uploadProductImage", data).then((res) => {
        this.product.thumbnailUrl = res;
        this.imageUrl = Util.getAppUrlImage(res);
        this.isUpload = true;
      });
    }

    return false;
  }
  handleRemoveAvatar() {
    this.isUpload = false;
    this.imageUrl = "";
    this.product.thumbnailUrl = "";
  }
  async getProductInfo() {
    await this.$store
      .dispatch({
        type: "product/get",
        data: { id: this.id },
      })
      .then((result) => {
        this.product = result;
        if (
          !_.isNil(this.product.thumbnailUrl) &&
          !_.isEmpty(this.product.thumbnailUrl)
        ) {
          this.imageUrl = Util.getAppUrlImage(this.product.thumbnailUrl);
          this.isUpload = true;
        } else {
          this.imageUrl = "";
          this.isUpload = false;
        }
        this.dataChildProducts = this.product.items;
        this.reorderDataChildProducts();
      });
  }
  validatorSku = (rule: any, value: any, callback: any) => {
    if (_.isNil(value) || _.isEmpty(value)) {
      callback();
    } else {
      if (
        this.product.externalCode !== value &&
        Util.isProductSkuFormat(value)
      ) {
        callback(new Error(this.L("Error.MatchedProductSkuFormat", undefined)));
      } else {
        callback();
      }
    }
  };
  productRule = {
    unitId: [
      {
        required: true,
        message: this.L("Error.RequiredField0", undefined, this.L("Unit")),
        trigger: "blur",
      },
    ],
    categoryId: [
      {
        required: true,
        message: this.L("Error.RequiredField0", undefined, this.L("Category")),
        trigger: "blur",
      },
    ],
    inventModel: [
      {
        required: true,
        message: this.L(
          "Error.RequiredField0",
          undefined,
          this.L("InventModel")
        ),
        trigger: "blur",
      },
    ],
    storageType: [
      {
        required: true,
        message: this.L(
          "Error.RequiredField0",
          undefined,
          this.L("StorageType")
        ),
        trigger: "blur",
      },
    ],
    type: [
      {
        required: true,
        message: this.L(
          "Error.RequiredField0",
          undefined,
          this.L("ProductType")
        ),
        trigger: "blur",
      },
    ],
    name: [
      {
        required: true,
        message: this.L("Error.RequiredField0", undefined, this.L("Name")),
        trigger: "blur",
      },
    ],
    tax: [
      {
        required: true,
        message: this.L("Error.RequiredField0", undefined, this.L("Tax")),
        trigger: "blur",
      },
    ],
  };

  childProductColumns = [
    {
      title: Util.L("Order"),
      width: 50,
      key: "orderNo",
    },
    {
      title: Util.L("Client"),
      key: "clientName",
    },
    {
      title: Util.L("Category"),
      key: "categoryName",
    },
    {
      title: Util.L("Unit"),
      key: "unitName",
    },
    {
      title: Util.L("Action"),
      slot: "actionChildProduct",
    },
  ];

  async getClients() {
    await this.$store
      .dispatch({
        type: "client/getListForSelect",
        data: { hasAllItem: false },
      })
      .then(() => {
        var re = this.$store.state.client.clientsForSelect;
        this.clients = re;
        this.selectChildClientCode = re[0].code;
        this.changeClientCode();
      });
  }

  async changeClientCode() {
    await this.getCategoriesOfClientForSelect();
    await this.getUnitsOfClientForSelect();
  }

  async getCategoriesOfClientForSelect() {
    await this.$store
      .dispatch({
        type: "category/getCategoriesByClientForSelect",
        data: { clientCode: this.selectChildClientCode },
      })
      .then(() => {
        var re = this.$store.state.category.categoriesOfClientForSelect;
        this.categoriesOfClient = re;
        this.selectChildCategoryId = 0;
      });
  }

  async getUnitsOfClientForSelect() {
    await this.$store
      .dispatch({
        type: "unit/getUnitsOfClientForSelect",
        data: { clientCode: this.selectChildClientCode },
      })
      .then(() => {
        var re = this.$store.state.unit.unitsOfClientForSelect;
        this.unitsOfClient = re;
        this.selectChildUnitId = 0;
      });
  }

  addChildProduct() {
    var indexNewChild = _.findIndex(this.dataChildProducts, [
      "clientCode",
      this.selectChildClientCode,
    ]);
    if (indexNewChild > -1) {
      Util.showNoticeErrorMsg(this, Util.L("ClientExistedInList"));
      return;
    }

    const item = {
      id: 0,
      clientCode: this.selectChildClientCode,
      clientName: _.result(
        _.find(this.clients, ["code", this.selectChildClientCode]),
        "displayName"
      ),
      categoryId: this.selectChildCategoryId,
      categoryName: _.result(
        _.find(this.categoriesOfClient, ["id", this.selectChildCategoryId]),
        "displayName"
      ),
      unitId: this.selectChildUnitId,
      unitName: _.result(
        _.find(this.unitsOfClient, ["id", this.selectChildUnitId]),
        "displayName"
      ),
    };
    this.dataChildProducts.push(item);
    this.reorderDataChildProducts();
  }

  removeChildProduct(row, index) {
    this.dataChildProducts.splice(index, 1);
    this.reorderDataChildProducts();
  }

  reorderDataChildProducts() {
    let index = 0;
    this.dataChildProducts.forEach(function (item) {
      item.orderNo = index + 1;
      index++;
    });
  }
}
